import { ITargetGroup } from '../../../entities/target-group/domain/target-group.types';

// Time window in milliseconds (30 minutes)
export const EDIT_TIME_WINDOW_MS = 30 * 60 * 1000;

/**
 * Determines if a target group is still editable based on its updatedAt timestamp
 *
 * @param targetGroup The target group to check
 * @returns An object containing the editability status and time information
 */
export const getTargetGroupEditStatus = (targetGroup: ITargetGroup, isAdmin: boolean) => {
  // If the target group is new (name is 'New target group' and no description),
  // it's always editable
  const isNewTargetGroup = !targetGroup.description;

  if (isNewTargetGroup) {
    return {
      isEditable: true,
      isNewTargetGroup,
      timeRemaining: null,
      timeElapsed: 0,
    };
  }

  const createdAt = new Date(targetGroup.createdAt).getTime();
  const now = Date.now();
  const timeElapsed = now - createdAt;

  // Time remaining in milliseconds before editing is locked
  const timeRemaining = Math.max(0, EDIT_TIME_WINDOW_MS - timeElapsed);

  const isEditable = (timeElapsed < EDIT_TIME_WINDOW_MS && !isNewTargetGroup) || isAdmin;

  return {
    isEditable,
    isNewTargetGroup: false,
    timeRemaining,
    timeElapsed,
  };
};

/**
 * Formats the remaining time in a human-readable format
 *
 * @param timeRemainingMs Time remaining in milliseconds
 * @returns Formatted time string
 */
export const formatRemainingTime = (timeRemainingMs: number): string => {
  if (timeRemainingMs <= 0) {
    return '0 minutes';
  }

  const minutes = Math.round(timeRemainingMs / (60 * 1000));
  return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
};
